import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SyndicateInfoModal = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="badge-info-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="badge-info-modal-header">
                    <h2 className="text-2xl font-bold text-cyan-300">{t('syndicateInfoModal.title')}</h2>
                    <button onClick={onClose} className="p-2 text-gray-400 hover:text-white"><LucideIcons.X size={24} /></button>
                </div>
                <div className="badge-info-modal-body">
                    <div className="space-y-4 text-gray-300">
                        <p>
                            {t('syndicateInfoModal.description')}
                        </p>
                        <div>
                            <h4 className="font-bold text-lg text-white mb-2">{t('syndicateInfoModal.howItWorksTitle')}</h4>
                            <ul className="list-disc list-inside space-y-2">
                                <li><span className="font-bold text-cyan-400">{t('syndicateInfoModal.joinOrCreate.title')}</span> {t('syndicateInfoModal.joinOrCreate.description')}</li>
                                <li><span className="font-bold text-cyan-400">{t('syndicateInfoModal.poolEchoes.title')}</span> {t('syndicateInfoModal.poolEchoes.description')}</li>
                                <li><span className="font-bold text-cyan-400">{t('syndicateInfoModal.increasedOdds.title')}</span> {t('syndicateInfoModal.increasedOdds.description')}</li>
                                <li><span className="font-bold text-cyan-400">{t('syndicateInfoModal.shareWinnings.title')}</span> {t('syndicateInfoModal.shareWinnings.description')}</li>
                            </ul>
                        </div>
                        <p className="font-bold text-center pt-4">
                            {t('syndicateInfoModal.callToAction')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SyndicateInfoModal;
